import { SET_BULK_LOAN, CLEAR_PARAMS_LOAN, SET_PARAMS_LOAN } from "constants/types";

const initialState = {
    search: "",
    page: 1,
    size: 10,
    status: "",
    composer_id: "",
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PARAMS_LOAN:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        case SET_BULK_LOAN:
            return {
                ...state,
                ...payload, // Make sure payload contains valid keys like `search` or `page`
            };
        case CLEAR_PARAMS_LOAN:
            return {
                ...state,
                search: "",
                page: 1,
            };
        default:
            return state;
    }
}
